<template>
  <div>
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <field-wrapper :label="labelText" option-label="label" :options="options.gtComparisonTypes" track-by="value"
                       v-model="values.comparison_one"
                       :error="errors.comparison_one" type="select"/>
      </div>
      <div class="col-lg-6 col-md-6">
        <field-wrapper v-model="values.threshold_one" :error="errors.threshold_one" label="Date" type="date"/>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <field-wrapper label="And" option-label="label" :options="options.ltComparisonTypes"  :error="errors.comparison_two" track-by="value"
                       v-model="values.comparison_two"
                       type="select"/>
      </div>
      <div class="col-lg-6 col-md-6">
        <field-wrapper v-model="values.threshold_two" :error="errors.threshold_two" label="Date" type="date"/>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <field-wrapper label="In Timezone (optional)" v-model="values.timezone" :options="options.timezones"
                       :error="errors.timezone"
                       type="select"/>
      </div>
    </div>
  </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'

  export default {
    components: {
      fieldWrapper
    },
    props: {
      values: Object,
      dateType: String,
      errors: Object
    },
    name: 'dateFilterTemplate',
    data () {
      return {
        options: FILTER_OPTIONS,
        labelText: this.dateType + ' date is'
      }
    },
    methods: {}
  }
</script>
<style>
</style>
